
export const setGame = game => {
  return {
    type: 'SET_GAME',
    payload: game
  }
}

export const startGame = () => {
  return {
    type: 'START_GAME',
  }
}

export const addPlayer = player => {
  return {
    type: 'ADD_PLAYER',
    payload: player
  }
}

export const setPlayers = players => {
  return {
    type: 'SET_PLAYERS',
    payload: players
  }
}

export const setCards = player => {
  return {
    type: 'SET_CARDS',
    payload: player,
  }
}

export const addToDrawPile = card => {
  return {
    type: 'ADD_DRAW_PILE',
    payload: card,
  }
}

const gameReducer = (state = null, action) => {
  switch (action.type) {
    case 'SET_GAME':
      return action.payload
    case 'START_GAME':
      return { ...state, running: true }
    case 'ADD_PLAYER':
      return { ...state, players: { ...state.players, [action.payload.uid]: { 'displayName': action.payload.displayName } } }
    case 'SET_PLAYERS':
      return { ...state, players: action.payload }
    case 'SET_CARDS':
      const { uid, cards } = action.payload
      return { ...state, players: { ...state.players, [uid]: { ...state.players[uid], cards, remainingCards: cards.length } } }
    case 'ADD_DRAW_PILE':
      return { ...state, drawPile: [...state.drawPile, action.payload] }
    default:
      return state
  }
}

export default gameReducer